export class UrlConstants {
    public static readonly getFile = 'Document/GetFile'; // {tenantId}/{authorizationNumber}/{fileName}
    public static readonly serviceLineMemberCriteria = 'ServiceLineMemberCriteria';
    public static readonly getProgramByBenefitPlanId = 'Program/ByBenefitPlanId';
    public static readonly userProfileCredentialsByEmail = 'Graph/GetUserProfileCredentialsByEmail';
    public static readonly searchAuthorizationByAuthorizationNumber = 'Search/SearchAuthorizationByAuthorizationNumber';
    public static readonly userProfilesListCredentialsByEmails = 'Graph/GetUserProfilesListCredentialsByEmails';
}